import { images } from './site';
import type { GalleryPhoto } from '../types/site';

export const galleryPhotos: GalleryPhoto[] = [
  {
    src: images.hood,
    alt: 'White commercial truck hood inside the workshop',
    caption: 'Commercial truck hood in the shop',
    layout: 'feature',
    objectPosition: '50% 45%',
  },
  {
    src: images.cab,
    alt: 'White commercial truck cab with a red stripe, parked outside',
    caption: 'Commercial cab and paintwork',
    layout: 'standard',
    objectPosition: '50% 55%',
  },
  {
    src: images.boxTruck,
    alt: 'Open box truck side wall structure with a technician at work',
    caption: 'Box truck body repairs',
    layout: 'standard',
    objectPosition: '50% 50%',
  },
];
